<h1 mat-dialog-title>Reservation Tags</h1>
<mat-dialog-content>
  <!--
    Inline help banner. Replaces the old "+ Add New Tag" shortcut: tag CRUD
    now lives in one place (Tag List) so categories, colors, and OP wiring
    can be configured at create-time rather than back-filled later. Also
    explains the lock icon to anyone who hasn't seen it before.
  -->
  <div class="info-banner" role="note" aria-label="Tag dialog help">
    <mat-icon class="info-icon" aria-hidden="true">info</mat-icon>
    <div class="info-text">
      <div>
        <mat-icon class="inline-lock" aria-hidden="true">lock</mat-icon>
        <strong>Locked tags</strong> are auto-applied based on the order products on this
        reservation. To add or remove a locked tag, edit the matching order product on
        the invoice. The wiring lives on the tag itself
        (<em>task_tag.orderProductId</em>) and is managed by an admin.
      </div>
      <div class="info-row-spacer"></div>
      <div>
        Need a new tag? Create it from the
        <a [routerLink]="['/tags']" (click)="close()" class="info-link">Tag List</a>
        page so you can set its category, color, and (optionally) the order
        product trigger. New tags appear here automatically next time you open this dialog.
      </div>
    </div>
  </div>

  <mat-form-field class="search-field" appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput placeholder="Search tags..." [(ngModel)]="searchQuery" (ngModelChange)="buildTagGroups()" />
  </mat-form-field>
  @if (tagGroups.length === 0) {
    <div class="no-results">No matching tags</div>
  }
  @for (group of tagGroups; track group) {
    <div class="tag-group">
      <h4 class="group-label">{{ group.label }}</h4>
      <div class="tag-list">
        @for (tag of group.tags; track tag) {
          <div class="tag-item" [class.op-wired]="isOpWired(tag)">
            <mat-checkbox [checked]="isSelected(tag)"
                          [disabled]="isOpWired(tag)"
                          (change)="onToggle(tag, $event)">
              {{ tag.name }}
              @if (isOpWired(tag)) {
                <mat-icon class="lock-icon"
                          [matTooltip]="opWiredTooltip(tag)"
                          matTooltipPosition="above">
                  lock
                </mat-icon>
              }
            </mat-checkbox>
          </div>
        }
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" type="button" (click)="close()">Close</button>
</mat-dialog-actions>
